export default {
  WEBSITE_NAME: process.env.VUE_APP_WEBSITE_NAME || "LinYing IM",
  BASE_API_URL: process.env.VUE_APP_API_BASE_URL || "",
  BASE_WS_URL: process.env.VUE_APP_WEB_SOCKET_URL || "",
  BASE_COMMON: process.env.VUE_APP_COMMON || "",
};
